
import AccountLogoutEverywhere from "../../components/account/AccountLogoutEverywhere.tsx";
import { ArrowRightStartOnRectangleIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../../hooks/useAuth.tsx";
import UtilsHelper from "../../helpers/utilsHelper.ts";
import AccountLayout from "../../components/layouts/AccountLayout.tsx";

const AccountPage = () => {
    const _authService = useAuth();
    UtilsHelper.changeWindowDocumentTitle("Konto");
    return (
        <AccountLayout>
            {/* <pre>{JSON.stringify(_authService.user)}</pre> */}
            <div className={"bg-neutral-900 p-6 md:p-10 max-w-lg rounded-3xl"}>
                <AccountLogoutEverywhere />
            </div>
            <div className={"h-0.5 w-full bg-neutral-700 my-4 md:hidden"} />
            <button
                onClick={_authService.logout}
                className={"md:hidden mx-auto flex text-lg items-center text-sky-500 hover:text-[#008dd2] transition-colors"}
            >WYLOGUJ<ArrowRightStartOnRectangleIcon className={"ml-2 w-6 h-6 stroke-2"} /></button>
        </AccountLayout>
    );
};

export default AccountPage;